(() => {
  const app = angular.module('app');
  angular.module('app').controller('clinic.views.hospital.query', ClinicQueryController);

  ClinicQueryController.$inject = [
    '$scope',
    '$stateParams',
    '$state',
    'abp.services.app.serviceRequestQuery',
  ];

  function ClinicQueryController($scope, $stateParams, $state, serviceRequestQuerySvc) {
    const vm = this;
    vm.loading = 0;
    vm.requestParams = {
      letterNumber: $stateParams.letterNumber,
      queryNumber: $stateParams.queryNumber,
      timeZoneId: $stateParams.timeZoneId,
    };
    vm.saving = 0;
    vm.checklistItems = [];

    // Attachment.

    const fileExtensions = `|${app.consts.fileUpload.imageExtensions
      .concat(app.consts.fileUpload.pdfExtensions)
      .join('|')}|`;

    vm.uploadConfig = {
      objectType: 'InpatientQueryAttachment',
      itemsLimit: 5,
      accept: 'image/*,application/pdf',
      filters: [
        {
          name: 'fileFilter',
          fn(n) {
            const t = `|${n.type.slice(n.type.lastIndexOf('/') + 1)}|`;
            if (fileExtensions.indexOf(t) === -1) {
              abp.message.warn(App.localize('File_Warn_FileType'));
              return false;
            }
            return true;
          },
        },
        {
          name: 'sizeFilter',
          fn(n) {
            const sizeLimit = 52428800;
            if (n.size > sizeLimit) {
              abp.message.warn(App.localize('File_Warn_XSizeLimit', sizeLimit / 1024 / 1024));
              return false;
            }
            return true;
          },
        },
      ],
    };

    // End attachment.

    vm.save = save;
    vm.getDateTimeString = getDateTimeString;

    init();

    function init() {
      getQuery();
    }

    function getQuery() {
      vm.loading += 1;
      serviceRequestQuerySvc
        .getQuery({ id: vm.requestParams.queryNumber })
        .success((data) => {
          vm.query = data;
          vm.query.newRepliedAttachments = [];
          AddChecklistItems(vm.query.serviceRequestQueryItems);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function AddChecklistItems(items) {
      const itemsList = items || [];
      vm.checklistItems = []; // reset to avoid duplicates

      if (_.some(itemsList, (item) => item.type === 1)) {
        vm.checklistItems.push({ text: App.localize('CompletedMedicalQueryForm'), required: true });
      }

      _.forEach(itemsList, (item) => {
        if (item.type === 2) {
          _.forEach(item.questions || [], (question) => {

            // use question.documentName when available (non-null/non-empty),
            //  otherwise fall back to content
            
            const textToAdd =
              vm.query &&
              question.documentName
                ? question.documentName
                : question.content || '';

            if (textToAdd) {
              vm.checklistItems.push({ text: textToAdd, required: true });
            }
          });
        }
      });
    }

    function save() {
      if (!validateForm()) {
        return;
      }

      vm.saving += 1;
      serviceRequestQuerySvc
        .replyQuery({ id: vm.query.id, newRepliedAttachments: vm.query.newRepliedAttachments })
        .success(() => {
          abp.notify.success(App.localize('SuccessfullySaved'));
          $state.go('clinic.patientAdmissionDetails', { letterNumber: $stateParams.letterNumber });
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    function validateForm() {
      vm.invalidAttachment = vm.query.newRepliedAttachments.length === 0;
      vm.invalidChecklist = !App.isFormValid($scope.forms.uploadDocuments);
      return !(vm.invalidAttachment || vm.invalidChecklist);
    }

    function getDateTimeString(date, timeZoneId) {
      return App.getDateTimeString(date, timeZoneId);
    }
  }
  // End functions.
})();
